import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Breadcrumb, BreadcrumbListComponent } from '@r1-compass-library/components';

@Component({
    selector: 'r1-compass-app-additional-play-info-bar',
    imports: [BreadcrumbListComponent],
    template: `
        <div id="additional-play-info-bar">
            <r1-compass-lib-breadcrumb-list [breadcrumbList]="crumbs()" />
            <p [style.color]="enabled() ? 'green' : 'red'">{{ enabled() ? 'Enabled' : 'Disabled' }}</p>
        </div>
    `,
    styles: `
        #additional-play-info-bar {
            display: flex;
            justify-content: space-between;
        }
        p {
            margin-top: 0;
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdditionalPlayInfoBarComponent {
    crumbs = input.required<Breadcrumb[]>();
    enabled = input.required<boolean>();
}
